import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { BUSINESS } from "@/lib/business";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-slate-900 text-slate-300 mt-20"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-cyan-500 text-slate-900 grid place-items-center font-display font-black text-lg">
              R
            </div>
            <div className="font-display font-extrabold text-white text-xl">
              {BUSINESS.name}
            </div>
          </div>
          <p className="mt-5 text-slate-400 max-w-md leading-relaxed text-sm">
            {BUSINESS.tagline}
          </p>
          <div className="mt-6 inline-flex items-center gap-2 border border-slate-700 px-3 py-1.5 text-[10px] tracking-[0.22em] uppercase font-semibold text-cyan-400">
            <MapPin className="w-3.5 h-3.5" /> {BUSINESS.serviceArea} · Service Area
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="text-[11px] tracking-[0.22em] uppercase text-slate-500 font-semibold mb-4">
            Navigation
          </div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" data-testid="footer-link-home" className="hover:text-white">Home</Link></li>
            <li><Link to="/services" data-testid="footer-link-services" className="hover:text-white">Services</Link></li>
            <li><Link to="/contact" data-testid="footer-link-contact" className="hover:text-white">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-[11px] tracking-[0.22em] uppercase text-slate-500 font-semibold mb-4">
            Get in touch
          </div>
          <ul className="space-y-3 text-sm">
            <li>
              <a
                href={BUSINESS.phoneHref}
                data-testid="footer-phone"
                className="inline-flex items-center gap-2 hover:text-white"
              >
                <Phone className="w-4 h-4 text-cyan-400" />
                {BUSINESS.phone}
              </a>
            </li>
            <li>
              <a
                href={BUSINESS.emailHref}
                data-testid="footer-email"
                className="inline-flex items-center gap-2 hover:text-white break-all"
              >
                <Mail className="w-4 h-4 text-cyan-400" />
                {BUSINESS.email}
              </a>
            </li>
            <li className="inline-flex items-center gap-2 text-slate-400">
              <MapPin className="w-4 h-4 text-cyan-400" />
              {BUSINESS.serviceArea}
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-xs text-slate-500 flex flex-col sm:flex-row justify-between gap-2">
          <div>© {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</div>
          <div>{BUSINESS.established}</div>
        </div>
      </div>
    </footer>
  );
}
